import { render, staticRenderFns } from "./RahbariyatTashriflar.vue?vue&type=template&id=6bd39076&scoped=true&"
import script from "./RahbariyatTashriflar.vue?vue&type=script&lang=js&"
export * from "./RahbariyatTashriflar.vue?vue&type=script&lang=js&"
import style0 from "./RahbariyatTashriflar.vue?vue&type=style&index=0&id=6bd39076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd39076",
  null
  
)

export default component.exports